import React, { Component } from "react";
import List from "@material-ui/core/List";
import { withStyles } from "@material-ui/core/styles";
import "@mdi/font/css/materialdesignicons.min.css";
import { contentClient } from "../../AxiosClient";
import ItemContentRevision from "../list-item/ItemContentRevision";

const styles = (theme) => ({
  badge: {
    display: "flex",
    height: "50%",
  },
});
export class SidebarEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edits: [],
    };
  }

  componentDidMount() {
    contentClient
      .get(`knowledgeitem/document/${this.props.documentId}/edits`)
      .then((res) => {
        this.setState({ edits: res.data.content });
      });
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps) {}

  render() {
    return (
      <>
        <div style={{ height: "100%" }}>
          <List>
            {this.state.edits.map((item, idx) => {
              return (
                <ItemContentRevision
                  key={idx}
                  onItemClick={this.onItemClick}
                  isPortlet={this.props.isPortlet}
                  documentSidebar={true}
                  fullscreen={this.props.fullscreen}
                  data={item}
                ></ItemContentRevision>
              );
            })}
          </List>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(SidebarEdit);
